import styled, { css } from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const StyledTypographyTitle = styled(Typography)`
  max-width: 19rem;
  margin-bottom: 2rem;

  ${breakpointsMedia({
    md: css`
      max-width: 27rem;
    `,
    lg: css`
      max-width: 19rem;
      margin-bottom: 2.5rem;
    `,
  })}
`;

StyledTypographyTitle.displayName = 'StyledTypographyTitle';

export const StyledTypographyText = styled(Typography)`
  ${breakpointsMedia({
    lg: css`
      max-width: 26rem;
      margin-right: 3rem;
    `,
  })}
`;

StyledTypographyText.displayName = 'StyledTypographyText';

